import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TopListItem, PlaylistInfo } from '@/types/ranking-api'

interface RankingState {
    topList: TopListItem[]
    playInfo: PlaylistInfo
    currentIndex?: number
}

const initialState: RankingState = {
    topList: [],
    playInfo: {} as PlaylistInfo,
    currentIndex: 0,
}

const rankingSlice = createSlice({
    name: 'ranking',
    initialState,
    reducers: {
        changeTopList(state, action: PayloadAction<TopListItem[]>) {
            state.topList = action.payload
        },
        changePlayInfo(state, action: PayloadAction<PlaylistInfo>) {
            state.playInfo = action.payload
        },
        changeCurrentIndex(state, action: PayloadAction<number>) {
            state.currentIndex = action.payload
        },
    },
})

export const { changePlayInfo, changeTopList, changeCurrentIndex } = rankingSlice.actions

export default rankingSlice.reducer
